import StockView from "../StockView.vue";
import StockEdit from "../layout/UpdateItem.vue";
import StockRegister from "../layout/Register.vue";

export const stockRoute = [
  {
    path: "/stock/",
    name: "stock",
    component: StockView,
    meta: {
      key: "view_est",
    },
  },
  {
    path: "/stock/edit/:id",
    name: "stock-edit",
    component: StockEdit,
    meta: {
      key: "edit_est",
    },
  },
  {
    path: "/stock/new",
    name: "stock-new",
    component: StockRegister,
    meta: {
      key: "add_est",
    },
  },
];
